import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';
import { DocumentSubCategoryDto } from './document-sub-category.dto';

export class DocumentCategoryDto extends EpimsBaseEntityDto {
  DocumentCategoryName: string;
  DocumentCategoryCode: string;
  SubscriptionUserId: string;  
  Version: number;
}
